import ButtonPrimary from 'components/ButtonPrimary/ButtonPrimary'
import HitModalStyle from 'components/HitDetailsModal/Style'
import Spinner from 'components/Spinner/Spinner'
import { Colors } from 'constants/colors'
import React from 'react'
import ErrorIcon from '@mui/icons-material/Error'
import { Typography } from '@mui/material'

interface RespondTextAreaProps {
  value: string
  setValue: React.Dispatch<React.SetStateAction<string>>
  errorMessage: string | null
  onSubmit: () => void
  loading: boolean
}

export default function RespondTextArea({
  value,
  setValue,
  errorMessage,
  onSubmit,
  loading,
}: RespondTextAreaProps): JSX.Element {
  return (
    <div
      style={{
        width: '100%',
      }}
    >
      <div style={{ position: 'relative' }}>
        <HitModalStyle.TextArea
          disabled={loading}
          placeholder="Type something..."
          value={value}
          onChange={(e) => setValue(e.target.value)}
          sx={errorMessage ? { borderColor: Colors.error } : {}}
          maxLength={10000}
        />
        {loading && <Spinner />}
      </div>
      {errorMessage && (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <ErrorIcon sx={{ color: Colors.error }} />
          <Typography sx={{ color: Colors.error }}>{errorMessage}</Typography>
        </div>
      )}
      <ButtonPrimary
        onClick={() => onSubmit()}
        buttonTitle="Submit"
        disabled={loading || value.trim().length === 0}
      />
    </div>
  )
}
